<template>
    <ClientLayout>
        <div class="text-xs-center">
            <v-btn round large color="primary" @click="reset">Reset All</v-btn>
        </div>
        <div class="text-xs-center">
            <v-btn round large color="primary" @click="complete">Complete All</v-btn>
        </div>
        <v-divider class="my-3"></v-divider>
        <div class="text-xs-center">
            <div class="subheading">Click to reset individual sections</div>
            <div class="caption">Click 'Home' after resetting one or more sections</div>
            <div class="caption">Purple sections have been completed</div>
            <v-btn
                round
                large
                v-for="section in reverse(sectionOrder)"
                :key="section"
                :class="{ primary: isComplete(section) }"
                @click="resetSection(section)"
                >{{ section }}</v-btn
            >
            <div class="mt-3">
                <v-btn round large color="primary" @click="home">Home</v-btn>
            </div>
        </div>
        <v-divider class="my-3"></v-divider>
        <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-flex shrink>
                <v-switch v-model="devmode" :label="'Dev Mode'"></v-switch>
            </v-flex>
            <v-spacer></v-spacer>
        </v-layout>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </ClientLayout>
</template>

<script>
import store from '@/store';
import router from '@/router';
import { get } from 'vuex-pathify';
import { clone, each, omit, reverse } from 'lodash';

export default {
    name: 'Reset',
    computed: {
        sectionOrder: get('sectionOrder'),
        devmode: {
            get: function() {
                return localStorage.devmode;
            },
            set: function(value) {
                if (value) {
                    localStorage.setItem('devmode', value);
                } else {
                    localStorage.removeItem('devmode');
                }
            }
        }
    },
    methods: {
        toggleDevMode() {
            if (localStorage.devmode) {
                localStorage.removeItem('devmode');
            } else {
                localStorage.setItem('devmode', true);
            }
        },
        reverse(arr) {
            return reverse(clone(arr));
        },
        isComplete(section) {
            return store.state[`section${section}`].complete;
        },
        reset() {
            this.$api.delete('/reset').then(() => {
                window.location.href = '/';
            });
        },
        complete() {
            each(this.sectionOrder, section => {
                this.$store.set(`section${section}/complete`, true);
                this.$store.set(`section${section}/sticker@earned`, true);
                if (store.state[`section${section}`].bonusSticker) {
                    this.$store.set(`section${section}/bonusSticker@earned`, true);
                }
                if (store.state[`section${section}`].trophy) {
                    this.$store.set(`section${section}/trophy@earned`, true);
                }
            });
            this.$api.post('/state', { data: omit(store.state, ['user', 'photo']) }).then(() => {
                window.location.href = '/';
            });
        },
        resetSection(section) {
            this.$store.commit(`section${section}/resetState`);
            this.$refs.modalFeedback.show(true, `Section ${section} has been reset`);
        },
        home() {
            router.push('/');
        }
    }
};
</script>
